export default __webpack_public_path__ + "static/media/cover-autolike@3x.71c33db7.png";